import React,{useContext,useState} from 'react'
import {Row,Col,Alert} from 'react-bootstrap'
import {Button} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {IoArrowBack} from 'react-icons/io5'
import Input from '../../../components/Input/index.js'
import {FaFacebookF} from 'react-icons/fa'
import {AiFillInstagram} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiFillPhone} from 'react-icons/ai'
import {ImLinkedin2} from 'react-icons/im'
import {FaTwitter} from 'react-icons/fa'
import {FaMediumM} from 'react-icons/fa'
import {FaGlobe} from 'react-icons/fa'
import {FaMapMarkerAlt} from 'react-icons/fa'
import {ImSkype} from 'react-icons/im'
import {SiQuora} from 'react-icons/si'
import {ImStackoverflow} from 'react-icons/im'
import {MdEmail} from 'react-icons/md'
import AuthContext from '../../../context/AuthContext.js'
import PrefixContext from '../../../context/PrefixContext.js'
import axios from 'axios'

function Index(props) {
    
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [data, setdata] = useState({...props.social})

    const onChangeHandler = (e) =>{
        const newData = {
            ...data
        }
        newData[e.target.name]=e.target.value;
        setdata(newData);
    }

    const saveChanges = (e) =>{
        e.preventDefault(); 
        if( validation.validationStatus !== 'LOADING')
        {
            setValidation({
                validationStatus: 'LOADING',
                validationStatusClass:'warning',
                validationStatusMessage: 'Please wait updating ...'
            });
            axios.post(PrefixContextData.prefixUrl + 'data/edit/social/'+props.handlerID, data)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                        });
                    }
                }
            });
        }
    }

    return (
        <>
            <h5 className="py-3">Edit Social Data</h5>
            <form onSubmit={(e)=>{saveChanges(e)}}>
                {(validation.validationStatus !== null && validation.validationStatus !== undefined)  && <div className="text-center">
                    <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
                </div>}
                <Row className="align-items-center small-inputcomponent modal-container">
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>LinkedIn</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="linkedin" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.linkedin  : null} placeholder="LinkedIn" icon={<ImLinkedin2/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Facebook</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="facebook" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.facebook : null} placeholder="Facebook" icon={<FaFacebookF/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Instagram</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="instagram" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.instagram : null} placeholder="Instagram" icon={<AiFillInstagram/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Twitter</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="twitter" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.twitter : null} placeholder="Twitter" icon={<FaTwitter/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Skype</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="skype" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.skype : null} placeholder="Skype" icon={<ImSkype/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Quora</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="quora" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.quora : null} placeholder="Quora" icon={<SiQuora/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Stackoverflow</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="stackoverflow" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.stackoverflow : null} placeholder="Stackoverflow" icon={<ImStackoverflow/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Medium</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="medium" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.medium : null} placeholder="Medium" icon={<FaMediumM/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Github</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="github" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.github : null} placeholder="Github" icon={<AiFillGithub/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Address</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="address" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.address : null} placeholder="Address" icon={<FaMapMarkerAlt/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Email</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="email" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.email : null} placeholder="Email" icon={<MdEmail/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Phone</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="phone" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.phone : null} placeholder="Phone" icon={<AiFillPhone/>}/>
                    </Col>
                    <Col md="2" className="text-left d-none d-md-block">
                        <label>Website</label>
                    </Col>
                    <Col md="10">
                        <Input className="w-100" name="website" onChangeHandler={onChangeHandler} defaultValue={(data !== undefined) ? data.website : null} placeholder="Website" icon={<FaGlobe/>}/>
                    </Col>
                </Row>
                <div className="d-flex p-3 justify-content-between">
                    <Button variant='white' className="border border-black" onClick={props.goBack}>
                        <div className="d-flex align-items-center">
                            <IconContext.Provider value={{color:'#6c757d'}}>
                                <IoArrowBack/> &nbsp;
                            </IconContext.Provider>
                            <p className="text-secondary mb-0">Go Back</p>
                        </div>
                    </Button>
                    <Button className="px-3 py-2" onClick={(e)=>{saveChanges(e)}}>
                        <div className="d-flex align-items-center">
                            <p className="mb-0">Save Changes</p>
                        </div>
                    </Button>
                </div>
            </form>
        </>
    )
}

export default Index
